<template>
  <c-form-group :id="id"
                v-slot="{ valid, errors, required, reset, invalid, dirty }"
                :form-group-class="formGroupClass"
                :has-feedback="hasFeedbackLeft || hasFeedbackRight ? true : false"
                :inline="inline"
                :input-wrapper-class="inputWrapperClass"

                :label="label"
                :label-class="labelClass"
                :label-invisible="labelInvisible"
                :label-right="labelRight"

                :validate-custom-messages="validateCustomMessages"
                :validate-disabled="validateDisabled"
                :validate-rules="validateRules"
                :validate-vid="validateVid"
  >
    <b-form-input :id="id"
                  v-bind="$attrs"
                  :class="{'has-feedback-left' : hasFeedbackLeft, 'has-feedback-right' : hasFeedbackRight}"
                  :placeholder="!hiddenPlaceholder ? placeholder || label : null"
                  :state="validateRules ? errors[0] ? false : (dirty && invalid ? false : null) : null"
                  :type="type"
                  :value="value"
                  @input="onInput"
    />
    <span v-if="hasFeedbackLeft" :class="hasFeedbackLeft" aria-hidden="true" class="form-control-feedback left"></span>
    <span v-if="hasFeedbackRight" :class="hasFeedbackRight" aria-hidden="true" class="form-control-feedback right"></span>
    <b-form-invalid-feedback v-if="errors[0]" style="cursor: pointer" @click="reset()">* {{ errors[0] }}</b-form-invalid-feedback>
  </c-form-group>
</template>

<script>
export default {
  name: "CInput",
  props: {
    value: {
      type: [String, Number],
      description: "Input value"
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: String,
    hiddenPlaceholder: Boolean,
    hasFeedbackLeft: String,
    hasFeedbackRight: String,

    formGroupClass: String,
    inline: Boolean,
    inputWrapperClass: String,
    label: String,
    labelClass: String,
    labelRight: Boolean,
    labelInvisible: Boolean,

    validateVid: String,
    validateRules: [Object, String],
    validateDisabled: Boolean,
    validateCustomMessages: Object,
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
    },
  },
  data() {
    return {
      id: null
    }
  },
  mounted() {
    this.id = 'cinput-' + this._uid;
  },
  computed: {
    classLabelComputed() {
      let obj = {
        'required': this.required,
        'col-form-label': this.inline,
        'label-align': this.labelRight
      }
      if (this.labelClass) {
        obj[this.labelClass] = true
      }
      return obj;
    },
    classFormGroupComputed() {
      let obj = {
        'has-feedback': this.hasFeedbackLeft || this.hasFeedbackRight,
        'row': this.inline
      }
      obj[this.formGroupClass] = this.formGroupClass;
      return obj;
    }
  }
}
</script>

<style scoped>

</style>